export const PROJECT_DETAILS_FIELDS: Record<
  string,
  { title: string; type?: string }
> = {
  id: { title: 'Id', type: 'string' },
  company: { title: 'Company', type: 'string' },
  project_title: { title: 'Project Title', type: 'string' },
  client_deadline: { title: 'Project Deadline', type: 'date' },
  genre: { title: 'Genre', type: 'string' },
  vertical: { title: 'Vertical', type: 'string' },
  language: { title: 'Language', type: 'string' },
  experience_level: { title: 'Experience Level', type: 'string' },
  project_amount_currency: { title: 'Project Currency', type: 'string' },
  project_amount: { title: 'Project Amount', type: 'currency' },
  reference_files: { title: 'Reference Files', type: 'file' },
  reference_links: { title: 'Reference Links', type: 'links' },
  article_links: { title: 'Article Links', type: 'links' },
  platforms: { title: 'Social Media Platforms', type: 'multiple' },
  category: { title: 'Category', type: 'string' },
  project_pay_type: { title: 'Project Pay Type', type: 'string' },
  audience_gender: { title: 'Audience Gender', type: 'string' },
  phased_delivery: { title: 'Phased Delivery', type: 'number' },
  phase_delivery: { title: 'Phase Delivery', type: 'boolean' }
}
